<template>
  <div>
    <treeselect
      :value="value"
      placeholder="Seleccione Entidad"
      :options="entities"
      @input="onInput"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';

export default {
  components: {
    Treeselect
  },
  methods: {
    onInput(value) {
      this.$emit('select-item', value);
    },
  },
  computed: {
    ...mapGetters('Materials', [
      'entities',
    ]),
  },
  props: {
    value: { type: String }
  }
};
</script>
<style lang="scss">
.vue-treeselect__input-container {
  input {
    padding: 10px;
  }
}
.vue-treeselect__control {
  border-color: #ccc;
}
</style>
